'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _I18n3 = require('I18n.React');

var _reactUtils = require('react-utils');

var _WidgetData = require('conversations-schema/records/WidgetData');

var _WidgetData2 = _interopRequireDefault(_WidgetData);

var _Conversation = require('conversations-schema/records/Conversation');

var _Conversation2 = _interopRequireDefault(_Conversation);

var _ChatFeedContainer = require('conversations-core/containers/ChatFeedContainer');

var _ChatFeedContainer2 = _interopRequireDefault(_ChatFeedContainer);

var _MessageEditor = require('conversations-core/components/chat/MessageEditor');

var _MessageEditor2 = _interopRequireDefault(_MessageEditor);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _RequestStatusTypes = require('conversations-schema/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

var _strings = require('conversations-core/constants/strings');

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'ChatArea',

  propTypes: {
    widgetData: _react.PropTypes.instanceOf(_WidgetData2.default).isRequired,
    currentChannel: _react.PropTypes.string,
    currentConversation: _react.PropTypes.instanceOf(_Conversation2.default).isRequired,
    chatHistoryFetchStatus: _react.PropTypes.oneOf(Object.keys(_RequestStatusTypes2.default)),
    fetchChatHistory: _react.PropTypes.func,
    mobile: _react.PropTypes.bool,
    publishMessage: _react.PropTypes.func,
    republishMessage: _react.PropTypes.func,
    chatInputChanged: _react.PropTypes.func,
    isOnlineMode: _react.PropTypes.bool.isRequired,
    preview: _react.PropTypes.bool,
    showEmailCapture: _react.PropTypes.bool.isRequired,
    emailCaptureMessageIndex: _react.PropTypes.number,
    emailCaptureMessage: _react.PropTypes.string.isRequired,
    visiblyOffline: _react.PropTypes.bool.isRequired,
    liveChatLink: _react.PropTypes.string,
    onLinkClick: _react.PropTypes.func.isRequired,
    hasUnansweredQuickReplyMessage: _react.PropTypes.bool,
    isAgentReady: _react.PropTypes.bool,
    publishChatMessage: _react.PropTypes.func.isRequired
  },

  componentDidUpdate: function componentDidUpdate(prevProps) {
    var lastChannel = prevProps.currentChannel;
    var _props = this.props,
        currentChannel = _props.currentChannel,
        fetchChatHistory = _props.fetchChatHistory;


    if (currentChannel !== lastChannel && lastChannel !== _strings.INITIAL_ONLINE_MODE_CHANNEL) {
      fetchChatHistory();
    }
  },
  hasChatHistoryResolved: function hasChatHistoryResolved() {
    var chatHistoryFetchStatus = this.props.chatHistoryFetchStatus;


    return chatHistoryFetchStatus === _RequestStatusTypes2.default.FAILED || chatHistoryFetchStatus === _RequestStatusTypes2.default.SUCCEEDED;
  },
  hasChatHistory: function hasChatHistory() {
    var history = this.props.currentConversation.chatHistory.history;


    return this.hasChatHistoryResolved() && history.size > 0;
  },
  chatAreaShouldBeDisabled: function chatAreaShouldBeDisabled() {
    var _props2 = this.props,
        isOnlineMode = _props2.isOnlineMode,
        history = _props2.currentConversation.chatHistory.history;


    return isOnlineMode && !(this.hasChatHistoryResolved() || history.size > 0);
  },
  renderBrandingLink: function renderBrandingLink() {
    var _props3 = this.props,
        liveChatLink = _props3.liveChatLink,
        onLinkClick = _props3.onLinkClick;

    return _react2.default.createElement(
      _UILink2.default,
      {
        style: { color: _colors.LORAX },
        href: liveChatLink,
        onClick: onLinkClick
      },
      _I18n2.default.text('input.chatArea.messages')
    );
  },
  renderWidgetBranding: function renderWidgetBranding() {
    var showingHsBranding = this.props.widgetData.showingHsBranding;


    if (showingHsBranding) {
      return _react2.default.createElement(
        'div',
        { className: 'text-center m-bottom-2' },
        _react2.default.createElement(_UIIcon2.default, {
          name: 'sprocket',
          alignment: 'middle',
          className: 'm-right-1',
          color: _colors.LORAX
        }),
        _react2.default.createElement(
          _Small2.default,
          { use: 'help' },
          _react2.default.createElement(_I18n3.FormattedReactMessage, {
            message: 'input.chatArea.branding',
            options: { messagesLink: this.renderBrandingLink() }
          })
        )
      );
    }
    return null;
  },
  renderChatFeed: function renderChatFeed() {
    var _props4 = this.props,
        isOnlineMode = _props4.isOnlineMode,
        _props4$widgetData = _props4.widgetData,
        firstName = _props4$widgetData.responder.firstName,
        coloring = _props4$widgetData.coloring,
        hasVisitorEmail = _props4$widgetData.hasVisitorEmail,
        fetchChatHistory = _props4.fetchChatHistory,
        extraProps = _objectWithoutProperties(_props4, ['isOnlineMode', 'widgetData', 'fetchChatHistory']);

    return _react2.default.createElement(_ChatFeedContainer2.default, _extends({
      currentRole: _RoleTypes2.default.VISITOR,
      responderName: firstName,
      isOnlineMode: isOnlineMode,
      coloring: coloring,
      hasVisitorEmail: hasVisitorEmail,
      fetchNextHistory: fetchChatHistory
    }, extraProps));
  },
  renderInitialMessage: function renderInitialMessage() {
    var _props5 = this.props,
        chatHistoryFetchStatus = _props5.chatHistoryFetchStatus,
        showEmailCapture = _props5.showEmailCapture,
        emailCaptureMessageIndex = _props5.emailCaptureMessageIndex,
        publishChatMessage = _props5.publishChatMessage,
        emailCaptureMessage = _props5.emailCaptureMessage,
        publishMessage = _props5.publishMessage;


    return _react2.default.createElement(_ChatFeedContainer2.default, {
      currentRole: _RoleTypes2.default.VISITOR,
      chatHistoryFetchStatus: chatHistoryFetchStatus,
      currentConversation: this.initialMessageConvo,
      showEmailCapture: showEmailCapture,
      emailCaptureMessageIndex: emailCaptureMessageIndex,
      emailCaptureMessage: emailCaptureMessage,
      publishChatMessage: publishChatMessage,
      publishMessage: publishMessage
    });
  },
  renderRTEorChatArea: function renderRTEorChatArea() {
    var _props6 = this.props,
        _props6$widgetData = _props6.widgetData,
        coloring = _props6$widgetData.coloring,
        showingHsBranding = _props6$widgetData.showingHsBranding,
        chatInputChanged = _props6.chatInputChanged,
        preview = _props6.preview,
        mobile = _props6.mobile,
        visiblyOffline = _props6.visiblyOffline,
        hasUnansweredQuickReplyMessage = _props6.hasUnansweredQuickReplyMessage,
        publishMessage = _props6.publishMessage;


    var disableInput = preview || hasUnansweredQuickReplyMessage || this.chatAreaShouldBeDisabled();

    var className = (0, _reactUtils.classNames)('input-container', 'm-bottom-2', {
      'no-branding': !showingHsBranding
    });

    return _react2.default.createElement(
      'div',
      { className: className },
      _react2.default.createElement(_MessageEditor2.default, {
        showingHsBranding: showingHsBranding,
        publishMessage: publishMessage,
        coloring: coloring,
        disabled: disableInput,
        chatInputChanged: chatInputChanged,
        mobile: mobile,
        visiblyOffline: visiblyOffline,
        currentRole: _RoleTypes2.default.VISITOR
      })
    );
  },
  render: function render() {
    return _react2.default.createElement(
      'div',
      { className: 'chat-area' },
      this.renderChatFeed(),
      this.renderRTEorChatArea(),
      this.renderWidgetBranding()
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/components/widget/ChatArea.js
// module id = 277
// module chunks = 0 1